var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"edit"},[_c('div',[_vm._v("审批通过后，员工状态将在转正日期后变为正式员工")])])
}]

export { render, staticRenderFns }